<template>
<main-content>
    <kt-panel>
        <kt-panel-body>
            <div class="row">
                <div class="col-12 col-md-6 my-2">
                    <kt-form-group>
                        <kt-form-label for="userid">
                            {{ $t('label.user_id') }}
                        </kt-form-label>
                        <kt-form-control dir="ltr" disabled aname="userid" id="userid" v-model="user.id"></kt-form-control>
                    </kt-form-group>
                </div>
            </div>
            <div class="line-divider mb-4"></div>
            <form v-if="status === 'success'" class="kt-form" @submit.prevent="update" id="profile_form">
                <div>
                    <div class="h5 mb-4">
                        <i class="text-primary far fa-building"></i>
                        <span class="px-2">{{ $t('legal_user.label.company_info') }}</span>
                    </div>
                    <kt-form-section>
                        <kt-form-row>
                            <kt-col md="6">
                                <kt-form-group>
                                    <kt-form-label for="username">
                                        {{ $t('label.username_with_hint') }}
                                    </kt-form-label>
                                    <kt-form-control dir="ltr" name="username" id="username" v-model="user.username"></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col md="6">
                                <kt-form-group>
                                    <kt-form-label for="email">
                                        {{ $t('label.email') }}
                                    </kt-form-label>
                                    <kt-form-control dir="ltr" name="email" id="email" v-model="user.email"></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col md="6">
                                <kt-form-group>
                                    <kt-form-label for="com_name_fa">
                                        {{ $t('label.com_name_fa') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            id="com_name_fa"
                                            name="com_name_fa"
                                            v-model="user.com_name_fa"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col md="6">
                                <kt-form-group>
                                    <kt-form-label for="com_name_en">
                                        {{ $t('label.com_name_en') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            id="com_name_en"
                                            name="com_name_en"
                                            dir="ltr"
                                            v-model="user.com_name_en"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col md="6">
                                <kt-form-group>
                                    <kt-form-label for="national_legal_code">
                                        {{ $t('label.national_legal_code') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            id="national_legal_code"
                                            name="national_legal_code"
                                            v-model="user.national_legal_code"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col md="6">
                                <kt-form-group>
                                    <kt-form-label for="register_number">
                                        {{ $t('label.register_number') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            id="register_number"
                                            name="register_number"
                                            v-model="user.register_number"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col md="6">
                                <kt-form-group>
                                    <kt-form-label for="register_date">
                                        {{ $t('label.com_register_date') }}
                                    </kt-form-label>
                                    <datePicker
                                            format="YYYY-MM-DD HH:mm:ss"
                                            display-format="jDD jMMMM jYYYY"
                                            input-class="form-control"
                                            id="register_date"
                                            name="register_date"
                                            v-model="user.register_date" type="date" />
                                </kt-form-group>
                            </kt-col>
                            <kt-col md="6">
                                <kt-form-group>
                                    <kt-form-label for="telephone">
                                        {{ $t('label.telephone') }}
                                    </kt-form-label>
                                    <kt-form-control ref="telephone" dir="ltr" name="telephone" id="telephone" v-model="user.telephone">
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col md="6">
                                <kt-form-group>
                                    <kt-form-label for="phone">
                                        {{ $t('label.phone') }}
                                    </kt-form-label>
                                    <kt-form-control dir="ltr" disabled name="phone" id="phone" :value="user.phone"></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                        </kt-form-row>
                    </kt-form-section>
                </div>

                <hr>

                <div>
                    <div class="h5 mb-4">
                        <i class="text-primary fas fa-file-signature"></i>
                        <span class="px-2">{{ $t('legal_user.label.signature_holder_info') }}</span>
                    </div>
                    <kt-form-section>
                        <kt-form-row>
                            <kt-col md="6">
                                <kt-form-group>
                                    <kt-form-label for="signature_holder_first_name_fa">
                                        {{ $t('label.first_name') }}
                                    </kt-form-label>
                                    <kt-form-control name="signature_holder_first_name_fa" id="signature_holder_first_name_fa" v-model="user.signature_holder.first_name_fa"></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col md="6">
                                <kt-form-group>
                                    <kt-form-label for="signature_holder_first_name_en">
                                        {{ $t('label.first_name_en') }}
                                    </kt-form-label>
                                    <kt-form-control dir="ltr" name="signature_holder_first_name_en" id="signature_holder_first_name_en" v-model="user.signature_holder.first_name_en"></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col md="6">
                                <kt-form-group>
                                    <kt-form-label for="signature_holder_last_name_fa">
                                        {{ $t('label.last_name') }}
                                    </kt-form-label>
                                    <kt-form-control name="signature_holder_last_name_fa" id="signature_holder_last_name_fa" v-model="user.signature_holder.last_name_fa"></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col md="6">
                                <kt-form-group>
                                    <kt-form-label for="signature_holder_last_name_en">
                                        {{ $t('label.last_name_en') }}
                                    </kt-form-label>
                                    <kt-form-control dir="ltr" name="signature_holder_last_name_en" id="signature_holder_last_name_en" v-model="user.signature_holder.last_name_en"></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col md="6">
                                <kt-form-group>
                                    <kt-form-label for="signature_holder_father_name_fa">
                                        {{ $t('label.father_name') }}
                                    </kt-form-label>
                                    <kt-form-control name="signature_holder_father_name_fa" id="signature_holder_father_name_fa" v-model="user.signature_holder.father_name_fa"></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col md="6">
                                <kt-form-group>
                                    <kt-form-label for="signature_holder_father_name_en">
                                        {{ $t('label.father_name_en') }}
                                    </kt-form-label>
                                    <kt-form-control dir="ltr" name="signature_holder_father_name_en" id="signature_holder_father_name_en" v-model="user.signature_holder.father_name_en"></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col md="6">
                                <kt-form-group>
                                    <kt-form-label for="signature_holder_birth_date">
                                        {{ $t('label.birth_date') }}
                                    </kt-form-label>
                                    <datePicker
                                            format="YYYY-MM-DD HH:mm:ss"
                                            display-format="dddd jDD jMMMM jYYYY"
                                            input-class="form-control"
                                            id="signature_holder_birth_date"
                                            name= "signature_holder_birth_date"
                                            v-model="user.signature_holder.birth_date"
                                            type="date" />
                                </kt-form-group>
                            </kt-col>
                            <kt-col md="6">
                                <kt-form-group>
                                    <kt-form-label for="signature_holder_national_code">
                                        {{ $t('label.national_code') }}
                                    </kt-form-label>
                                    <kt-form-control dir="ltr" maxlength="10" name="signature_holder_national_code" id="signature_holder_national_code" v-model="user.signature_holder.national_code"></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                        </kt-form-row>
                    </kt-form-section>
                </div>

                <hr>

                <div>
                    <div class="h5 mb-4">
                        <i class="text-primary fas fa-laptop-code"></i>
                        <span class="px-2">{{ $t('legal_user.label.technical_agent_info') }}</span>
                    </div>
                    <kt-form-section>
                        <kt-form-row>
                            <kt-col md="6">
                                <kt-form-group>
                                    <kt-form-label for="technical_agent_first_name">
                                        {{ $t('label.first_name') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            name="technical_agent_first_name"
                                            id="technical_agent_first_name"
                                            v-model="user.technical_agent.first_name"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col md="6">
                                <kt-form-group>
                                    <kt-form-label for="technical_agent_last_name">
                                        {{ $t('label.last_name') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            id="technical_agent_last_name"
                                            name="technical_agent_last_name"
                                            v-model="user.technical_agent.last_name"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col md="6">
                                <kt-form-group>
                                    <kt-form-label for="technical_agent_phone_number">
                                        {{ $t('label.phone') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            dir="ltr"
                                            id="technical_agent_phone_number"
                                            name="technical_agent_phone_number"
                                            v-model="user.technical_agent.phone_number"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col md="6">
                                <kt-form-group>
                                    <kt-form-label for="technical_agent_telephone_number">
                                        {{ $t('label.telephone') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            dir="ltr"
                                            id="technical_agent_telephone_number"
                                            name="technical_agent_telephone_number"
                                            v-model="user.technical_agent.telephone_number"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col md="6">
                                <kt-form-group>
                                    <kt-form-label for="technical_agent_email">
                                        {{ $t('label.email') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            dir="ltr"
                                            id="technical_agent_email"
                                            name="technical_agent_email"
                                            v-model="user.technical_agent.email"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col md="6">
                                <kt-form-group>
                                    <kt-form-label for="technical_agent_national_code">
                                        {{ $t('label.national_code') }}
                                    </kt-form-label>
                                    <kt-form-control
                                            dir="ltr"
                                            id="technical_agent_national_code"
                                            name="technical_agent_national_code"
                                            v-model="user.technical_agent.national_code"
                                    >
                                    </kt-form-control>
                                </kt-form-group>
                            </kt-col>
                        </kt-form-row>
                    </kt-form-section>
                </div>

                <kt-form-action class="mt-4" v-if="user.is_authenticated !== true">
                    <button class="btn btn-md btn-success btn-wide" type="submit" id="submit_btn">
                        {{ $t('btn.submit') }}
                    </button>
                </kt-form-action>
            </form>
        </kt-panel-body>
    </kt-panel>
    <change-phone-number/>
</main-content>
</template>

<script>
import mainContent from './Base'
import $ from 'jquery'
import { mapState } from 'vuex'
import { KTApp } from '@/plugins/core/app'
import { KTUtil } from '@/plugins/core/util'
import { userService } from '@/common/api.service'
import Inputmask from 'inputmask'
import {i18n} from "@/plugins/i18n";
import { birthCrtfctSeriesLetters } from '@/constants/birthCrtfctSeriesLetter'
import ChangePhoneNumber from "@/views/profile/ChangePhoneNumber.vue";

export default {
    name: 'profile.update',
    components: {
        ChangePhoneNumber,
        'main-content': mainContent,
    },
    data: function() {
        return {
            birthCrtfctSeriesLetters: birthCrtfctSeriesLetters,
            user: this.$store.state.user.current_user,
            months: [
                {
                    title: i18n.t('month.farvardin'),
                    value: 1
                },
                {
                    title: i18n.t('month.ordibehesht'),
                    value: 2
                },
                {
                    title: i18n.t('month.khordad'),
                    value: 3
                },
                {
                    title: i18n.t('month.tir'),
                    value: 4
                },
                {
                    title: i18n.t('month.mordad'),
                    value: 5
                },
                {
                    title: i18n.t('month.shahrivar'),
                    value: 6
                },
                {
                    title: i18n.t('month.mehr'),
                    value: 7
                },
                {
                    title: i18n.t('month.aban'),
                    value: 8
                },
                {
                    title: i18n.t('month.azar'),
                    value: 9
                },
                {
                    title: i18n.t('month.day'),
                    value: 10
                },
                {
                    title: i18n.t('month.bahman'),
                    value: 11
                },
                {
                    title: i18n.t('month.esfand'),
                    value: 12
                },
            ],
        }
    },
    computed: {
        ...mapState('user', {
            status: state => state.status,
        })
    },
    watch: {
        status() {
            this.user = this.$store.state.user.current_user
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => vm.$store.dispatch('user/fetchCurrent').then(() => {
            vm.checkForDisableForm()
        }))
    },
    mounted() {
        this.$nextTick(function () {
            this.initialSetup()
        })
    },
    methods: {
        checkForDisableForm() {
            if (this.user.is_authenticated) {
                $("#profile_form :input").prop("disabled", true);
            }
        },
        initialSetup() {
            setTimeout(() => {
                document.getElementById('telephone') && Inputmask('099-99999999').mask(document.getElementById('telephone'))
            }, 1000)
            
        },
        update(e) {
            let form = $(e.target)
            let btn = $('#submit_btn')

            form.validate({
                ignore: ":hidden",

                rules: {
                    username: {
                        required: true,
                        minlength: 5,
                    },
                    email: {
                        required: true,
                    },
                    telephone: {
                        required: true,
                    },
                    phone: {
                        required: true,
                    },
                    com_name_fa: {
                        required: true,
                    },
                    com_name_en: {
                        required: true,
                    },
                    national_legal_code: {
                        required: true,
                    },
                    register_number: {
                        required: true,
                    },
                    register_date: {
                        required: true,
                    },

                    signature_holder_first_name_fa: {
                        required: true,
                    },
                    signature_holder_last_name_fa: {
                        required: true,
                    },
                    signature_holder_father_name_fa: {
                        required: true,
                    },
                    signature_holder_first_name_en: {
                        required: true,
                    },
                    signature_holder_last_name_en: {
                        required: true,
                    },
                    signature_holder_father_name_en: {
                        required: true,
                    },
                    signature_holder_national_code: {
                        required: true,
                    },
                    signature_holder_birth_date: {
                        required: true,
                    },

                    technical_agent_first_name: {
                        required: true,
                    },
                    technical_agent_last_name: {
                        required: true,
                    },
                    technical_agent_phone_number: {
                        required: true,
                    },
                    technical_agent_telephone_number: {
                        required: true,
                    },
                    technical_agent_email: {
                        required: true,
                    },
                    technical_agent_national_code: {
                        required: true,
                    }
                },
            });


            if(!form.valid()) {
                return
            }

            let params = {
                username: this.user.username,
                email: this.user.email,
                phone: this.user.phone,
                telephone: this.user.telephone,
                com_name_fa: this.user.com_name_fa,
                com_name_en: this.user.com_name_en,
                national_legal_code: this.user.national_legal_code,
                register_number: this.user.register_number,
                register_date: this.user.register_date,

                signature_holder_first_name_fa: this.user.signature_holder.first_name_fa,
                signature_holder_last_name_fa: this.user.signature_holder.last_name_fa,
                signature_holder_father_name_fa: this.user.signature_holder.father_name_fa,
                signature_holder_first_name_en: this.user.signature_holder.first_name_en,
                signature_holder_last_name_en: this.user.signature_holder.last_name_en,
                signature_holder_father_name_en: this.user.signature_holder.father_name_en,
                signature_holder_national_code: this.user.signature_holder.national_code,
                signature_holder_birth_date: this.user.signature_holder.birth_date,

                technical_agent_first_name: this.user.technical_agent.first_name,
                technical_agent_last_name: this.user.technical_agent.last_name,
                technical_agent_phone_number: this.user.technical_agent.phone_number,
                technical_agent_telephone_number: this.user.technical_agent.telephone_number,
                technical_agent_email: this.user.technical_agent.email,
                technical_agent_national_code: this.user.technical_agent.national_code,
            }

            KTApp.progress(btn)
            userService.update_legal_user(params)
            .then(response => {
                this.$store.commit('user/success', response.data.data)
                this.showMsg(form, 'success', response.data.message)
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            })
            .finally(() => {
                KTUtil.scrollTop()
                KTApp.unprogress(btn)
            })
        },
        getYear() {
            return new Date().getFullYear() - 721
        },
    }
}
</script>

<style>
.kt-nav .kt-nav__item > .router-link-exact-active {
    background-color: #f7f8fa!important;
}
.router-link-exact-active > .kt-nav__link-icon,
.router-link-exact-active > .kt-nav__link-text {
    color: #5d78ff!important;
}
</style>